import { render, staticRenderFns } from "./widget_bMenu.vue?vue&type=template&id=1ef96ba1&scoped=true"
import script from "./widget_bMenu.vue?vue&type=script&lang=js"
export * from "./widget_bMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef96ba1",
  null
  
)

export default component.exports